// extracted by mini-css-extract-plugin
export default {"section":"Information_section__E3aoM","sider":"Information_sider__v70xA","content":"Information_content__MJEt3","links":"Information_links__aFE2h"};